/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StripeStatus = "MORE_REQUIRED" | "NOT_STARTED" | "ONBOARDED" | "%future added value";
export type Api_account = {
    readonly merchant: {
        readonly payments: {
            readonly stripeSetupStatus: StripeStatus;
        } | null;
    } | null;
    readonly " $refType": "Api_account";
};
export type Api_account$data = Api_account;
export type Api_account$key = {
    readonly " $data"?: Api_account$data;
    readonly " $fragmentRefs": FragmentRefs<"Api_account">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Api_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Merchant",
      "kind": "LinkedField",
      "name": "merchant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Payments",
          "kind": "LinkedField",
          "name": "payments",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stripeSetupStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};
(node as any).hash = 'cdf7ee00882f65c43ce5832daebe473a';
export default node;
